<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";

import Stats from "./stats";
import ChartWeekly from "./chartWeekly";
/**
 * Dashboard component
 */
export default {
  components: {
    Layout,
    PageHeader,
    Stats,
    ChartWeekly,
  },
  data() {
    return {
      title: "Gösterge Paneli",
      items: [
        {
          text: "Reservation Track System (RTS)",
        },
        {
          text: "Gösterge Paneli",
          active: true,
        },
      ],
    };
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <Stats />
      </div>
      <div class="col-lg-4">
        <ChartWeekly />
      </div>
    </div>
  </Layout>
</template>
